import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FeeInputService {
  // Strip invalid characters and allow only a single decimal point.
  sanitize(value: string): string {
    return value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
  }

  // Enforce numeric-only keypresses with a single decimal point.
  onKeydown(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement | null;
    if (!input) return;

    const allowedKeys = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'Tab',
      'Home',
      'End',
    ];
    if (allowedKeys.includes(event.key)) return;

    if (event.key === '.') {
      if (input.value.includes('.')) {
        event.preventDefault();
      }
      return;
    }

    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }

  // Sanitize input value on typing.
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement | null;
    if (!input) return;
    const sanitized = this.sanitize(input.value);
    if (input.value !== sanitized) {
      input.value = sanitized;
    }
  }

  // Sanitize pasted content.
  onPaste(event: ClipboardEvent): void {
    const input = event.target as HTMLInputElement | null;
    const text = event.clipboardData?.getData('text') ?? '';
    if (!input || text === '') return;

    const sanitized = this.sanitize(text);
    if (sanitized !== text) {
      event.preventDefault();
      const start = input.selectionStart ?? input.value.length;
      const end = input.selectionEnd ?? input.value.length;
      input.value =
        input.value.substring(0, start) +
        sanitized +
        input.value.substring(end);
    }
  }

  // Normalize to 2-decimal format for display.
  formatFeeValue(value: string): string {
    if (!value) return '';
    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) return '';
    return numericValue.toFixed(2);
  }
}
